// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1f2aM","notes":"Notes_notes__1L_d-","note":"Notes_note__35_pv","markdown":"Notes_markdown__3hfr7"};